module.exports = __webpack_public_path__ + "images/assets/d4937b891632bbfd5cb0d263560131a5.svg";